import { MapElementFactory } from 'gmap-vue'

export default MapElementFactory({
    name: 'directionsRenderer',

    ctr() {
        return window.google.maps.DirectionsRenderer
    },

    events: [],

    mappedProps: {},

    props: {
        origin: {
            type: Object,
            default: null
        },
        destination: {
            type: Object,
            default: null
        },
        travelMode: {
            type: String,
            default: 'DRIVING'
        },
        polylineOptions: {
            type: Object,
            default: () => ({})
        },
        directions: {
            type: Object,
            default: null
        },
    },

    afterCreate(directionsRenderer) {
        const directionsService = new window.google.maps.DirectionsService()

        // Watch para polylineOptions separadamente para atualizar estilo sem recalcular rota
        this.$watch(() => this.polylineOptions, (newOptions) => {
            if (newOptions && Object.keys(newOptions).length > 0) {
                const currentOptions = directionsRenderer.getOptions() || {}
                directionsRenderer.setOptions({
                    ...currentOptions,
                    suppressMarkers: true,
                    polylineOptions: newOptions
                })
            }
        }, { deep: true })

        // Se directions for fornecido, usar diretamente
        this.$watch(() => this.directions, (directions) => {
            if (directions && directions.routes && directions.routes.length > 0) {
                const options = {
                    suppressMarkers: true,
                }
                if (this.polylineOptions && Object.keys(this.polylineOptions).length > 0) {
                    options.polylineOptions = this.polylineOptions
                }
                directionsRenderer.setOptions(options)
                directionsRenderer.setDirections(directions)
            }
        }, { deep: true, immediate: true })

        // Se directions não for fornecido, calcular rota usando origin/destination
        this.$watch(() => {
            const { origin, destination, travelMode, directions } = this
            // Só calcular se directions não foi fornecido
            if (directions) {
                return
            }
            if (!origin || !destination || !travelMode) {
                return
            }

            directionsService.route(
                {
                    origin,
                    destination,
                    travelMode,
                },
                (response, status) => {
                    if (status === 'OK') {
                        const options = {
                            suppressMarkers: true,
                        }
                        if (this.polylineOptions && Object.keys(this.polylineOptions).length > 0) {
                            options.polylineOptions = this.polylineOptions
                        }
                        directionsRenderer.setOptions(options)
                        directionsRenderer.setDirections(response)
                    }
                }
            )
        })
    },
})
